  <template>
<div class="auther_table_wrap">
  <el-table
      :data="channels"
      border
      style="width:95.2%;margin:0px auto;" size="medium" >
      <el-table-column
        prop="channel_id"
        label="频道编码"
        width="100">
      </el-table-column>
      <el-table-column
        prop="name"
        label="频道名称">
      </el-table-column>
      <el-table-column
        prop="article_count"
        label="文章数">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          {{scope.row.is_visible===1?'可见':'不可见'}}
        </template>
      </el-table-column>
      <el-table-column
      label="操作"
      width="160">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="fnPopShow(scope.row.channel_id,scope.row.name,scope.row.is_visible)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="fnDelChannel(scope.row.channel_id)">删除</el-button>
        </template>
      </el-table-column>
   </el-table>

    <el-dialog title="修改频道" :visible.sync="pop_show" append-to-body>
        <el-form :model="ChannelsForm" status-icon :rules="rulesChannelsForm" ref="ChannelsForm" label-width="100px">
          <el-form-item label="频道名词：" prop="name">
            <el-input type="text" v-model="ChannelsForm.name" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="是否启用：" prop="is_visible">
            <template>
              <el-radio-group v-model="ChannelsForm.is_visible">
                <el-radio :label="0">禁用</el-radio>
                <el-radio :label="1">启用</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="resetForm('ChannelsForm')">重置</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>

</div>
</template>

<script>
import cons from '@/components/constant';

export default {
  name: 'OptionsTable',
  props:['channels'],
   data () {
    return {
      pop_show:false,
      group_type_list:[],
      category_list:[],
      ChannelsForm:{
        name:'',
        is_visible:'',
        sequence:''
      },
      rulesChannelsForm:{
      }
    }
  },
  methods:{
  	fnPopShow(id, name, stu){
  		this.pop_show = true;
      this.edit_id = id;

      this.ChannelsForm.name = name;
      this.ChannelsForm.is_visible = stu;
  	},
  	submitForm(){
      let token = localStorage.token;
  		this.axios.put(cons.apis + '/v1_0/channels/'+this.edit_id, {
              "name": this.ChannelsForm.name,
              "is_visible": this.ChannelsForm.is_visible,
              "sequence": 1
            }, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        }).then(dat=>{
          this.$message({
            type: 'success',
            message: '频道修改成功!'
          });
        	this.pop_show = false;
          this.resetForm('ChannelsForm');
          this.$emit('fnResetTable');
        }).catch(err=>{
        	console.log(err.response);
        })
  	},
  	fnDelChannel(id){
      let token = localStorage.token;
        this.edit_id = id;
        this.$confirm('此操作将删除该频道, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.delete(cons.apis + '/v1_0/channels/'+this.edit_id,{
              headers: {
                'Authorization': 'Bearer ' + token
              },
              responseType:'json'
          }).then(dat=>{
            this.$message({
              type: 'success',
              message: '删除频道成功!'
            });
            this.$emit('fnResetTable');
          }).catch(err=>{
            if(err.response.status==404){
               this.$message({
                  type:'info',
                  message:'频道未找到！'
                });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
  	},
    fnGetChannelType(){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/goods/channel_types/', {
        headers: {
          'Authorization': 'JWT ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{
          this.group_type_list = dat.data;
      }).catch(err=>{
         console.log(err.response);
      });
    },
    fnGetCategories(){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/goods/categories/', {
        headers: {
          'Authorization': 'JWT ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{
          this.category_list = dat.data;
      }).catch(err=>{
         console.log(err.response);
      });
    },
    resetForm(formName){
      this.$refs[formName].resetFields();
    }
  },
  mounted(){
    // this.fnGetChannelType();
    // this.fnGetCategories();
  }
}
</script>

<style scope>
.el-table th,.el-table td{
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/ChannelsTable.vue